import { render, staticRenderFns } from "./version-info.vue?vue&type=template&id=37b42a4f&scoped=true&"
import script from "./version-info.vue?vue&type=script&lang=js&"
export * from "./version-info.vue?vue&type=script&lang=js&"
import style0 from "./version-info.vue?vue&type=style&index=0&id=37b42a4f&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b42a4f",
  null
  
)

export default component.exports